<template>
  <dl class="">
    <h2 class="page_title ab c5a">インボイス登録番号更新</h2>
    <div class="form_list">
      <dt class="form_title ar">インボイス番号</dt>
      <dd class="form_contents">
        <span class="rb c5a">T</span><input class="input c5a rb" type="tel" maxlength="13" :value="localInvoiceNumber" @input="updateInputInvoiceNumber">
      </dd>
    </div>
    <div class="mt24">
      <button @click="updateInvoiceNumber()" type="button" name="button" class="btn btn_blue">更新</button>
    </div>
  </dl>
</template>

<script>
import SectionTitle from '@/components/common/SectionTitle';

export default {
  props: ['invoiceNumber'],
  components: {
    SectionTitle,
  },
  data() {
    return {
      localInvoiceNumber: this.invoiceNumber
    };
  },
  methods: {
    updateInputInvoiceNumber(event) {
      const newValue = event.target.value.slice(0, 13);
      this.localInvoiceNumber = newValue;
      this.$emit('update:inputInvoiceNumber', this.localInvoiceNumber);
    },
    updateInvoiceNumber() {
      this.$emit('updateInvoiceNumber');
    }
  }
}
</script>

<style lang="css" scoped>
.input {
  border: none;
  color: #5a5a5a;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 16px;
  width: 100%!important;
}
.form_contents {
  align-items: center;
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  margin-top: 5px;
  padding-bottom: 10px;
}
.form_title {
  color: #878787;
  font-size: 12px;
}
.form_list {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/member/invoice/UpdateInvoiceNumber.vue